import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-row space-x-8" }
const _hoisted_2 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_3 = { class: "flex flex-row space-x-8" }
const _hoisted_4 = /*#__PURE__*/_createVNode("hr", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_Title = _resolveComponent("Title")!
  const _component_LpInput = _resolveComponent("LpInput")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_MultipleSelectSearch = _resolveComponent("MultipleSelectSearch")!
  const _component_Pickers = _resolveComponent("Pickers")!
  const _component_SectionTiersCalculation = _resolveComponent("SectionTiersCalculation")!
  const _component_ChipsV2 = _resolveComponent("ChipsV2")!
  const _component_DetailLayout = _resolveComponent("DetailLayout")!

  return (_openBlock(), _createBlock(_component_DetailLayout, {
    scrollSidebar: "",
    customClass: "px-0",
    onBack: _ctx.goBack,
    title: "Ubah Konfigurasi Cashback",
    loading: _ctx.apiDetailData.loading,
    error: !!_ctx.apiDetailData.errorType,
    errorType: _ctx.apiDetailData.errorType,
    onTryAgain: _ctx.fetchDetail,
    "leave-page-confirmation": _ctx.leavePageConfirmation,
    "onUpdate:leave-page-confirmation": _cache[2] || (_cache[2] = ($event: any) => (_ctx.leavePageConfirmation = $event)),
    onLeavePage: _ctx.onLeavePage
  }, {
    "top-right": _withCtx(() => [
      _createVNode(_component_LpButton, {
        customClass: "px-12 py-2.5",
        fontWeight: "semibold",
        title: "Simpan",
        textColor: "white",
        onClick: _ctx.onShowModalConfirm,
        disabled: !_ctx.isFormValid
      }, null, 8, ["onClick", "disabled"])
    ]),
    data: _withCtx(() => [
      _createVNode(_component_Title, {
        label: "Kriteria Partner",
        class: "text-20px"
      }),
      _createVNode("div", _hoisted_1, [
        _createVNode(_component_DataWrapper, {
          label: "Tipe Akun",
          asterisk: "",
          class: "w-4/12"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_LpInput, {
              modelValue: _ctx.accountTypeValue,
              disabled: "",
              disableBackground: ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_DataWrapper, {
          label: "Nama POS",
          asterisk: "",
          class: "w-4/12"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_MultipleSelectSearch, {
              "modal-title": "Nama POS",
              "option-name": "name",
              onFocus: _ctx.filterPos,
              onFilter: _ctx.filterPos,
              onChange: _ctx.onSelectPartner,
              options: _ctx.listPos,
              modelValue: _ctx.searchPartner,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.searchPartner = $event)),
              keyName: "name",
              keyValue: "id",
              placeholder: "Ketik atau pilih nama pos",
              isLoading: _ctx.isLoadingPartner,
              showReset: "",
              "able-to-delete-in-modal": "",
              customDisplayAll: "Semua POS",
              onReset: _ctx.onResetFilter,
              class: "mt-2"
            }, null, 8, ["onFocus", "onFilter", "onChange", "options", "modelValue", "isLoading", "onReset"])
          ]),
          _: 1
        })
      ]),
      _hoisted_2,
      _createVNode(_component_Title, {
        label: "Aturan Cashback",
        class: "text-20px"
      }),
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_DataWrapper, {
          label: "Tanggal Mulai",
          asterisk: "",
          class: "w-4/12"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Pickers, {
              modelValue: _ctx.periodeStart,
              disabled: ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_DataWrapper, {
          label: "Tanggal Berakhir",
          asterisk: "",
          class: "w-4/12"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Pickers, {
              modelValue: _ctx.periodeEnd,
              onSelected: _ctx.inputDateEnd,
              minDate: _ctx.minDateEndDate
            }, null, 8, ["modelValue", "onSelected", "minDate"])
          ]),
          _: 1
        })
      ]),
      _createVNode(_component_DataWrapper, {
        label: "Tipe Cashback",
        asterisk: "",
        class: "w-14/20 capitalize"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_LpInput, {
            modelValue: _ctx.ccbTypeValue,
            disabled: "",
            disableBackground: ""
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _hoisted_4,
      _createVNode(_component_SectionTiersCalculation)
    ]),
    "sub-data": _withCtx(() => [
      _createVNode(_component_DataWrapper, { label: "Status" }, {
        default: _withCtx(() => [
          _createVNode(_component_ChipsV2, {
            class: "pt-2",
            label: _ctx.detailData.data.ccbStatus
          }, null, 8, ["label"])
        ]),
        _: 1
      }),
      _createVNode(_component_DataWrapper, {
        label: "Terakhir Diubah",
        value: _ctx.detailData.data.formatCreatedAt,
        caption: _ctx.detailData.data.ccbCreatedBy
      }, null, 8, ["value", "caption"]),
      _createVNode(_component_DataWrapper, {
        class: "capitalize",
        label: "Tanggal Dibuat",
        value: _ctx.detailData.data.formatUpdatedAt,
        caption: _ctx.detailData.data.ccbUpdatedBy
      }, null, 8, ["value", "caption"])
    ]),
    _: 1
  }, 8, ["onBack", "loading", "error", "errorType", "onTryAgain", "leave-page-confirmation", "onLeavePage"]))
}